export function areSetsEquivalent<T = string>(set1: Set<T>, set2: Set<T>): boolean {
  return set1.size === set2.size &&
    [...set1].every((item) => set2.has(item));
}
